import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

let _cache = null;
async function hentPakker() {
  if (_cache) return _cache;
  const { data } = await api.get("/admin/os/packages");
  _cache = data.packages || [];
  return _cache;
}

export function PakkeVelger({ verdi, onVelg, testid, label = "Pakke" }) {
  const [pakker, setPakker] = useState([]);
  const [ny, setNy] = useState(false);
  const [navn, setNavn] = useState("");

  useEffect(() => { hentPakker().then(setPakker).catch(() => setPakker([])); }, []);

  const lagreNy = async (e) => {
    e.preventDefault();
    const n = navn.trim();
    if (!n) return;
    try {
      const { data } = await api.post("/admin/os/packages", { name: n });
      _cache = null;
      setPakker(await hentPakker());
      setNy(false);
      setNavn("");
      onVelg(data.package.name);
    } catch { toast.error("Kunne ikke opprette pakken"); }
  };

  if (ny) {
    return (
      <form onSubmit={lagreNy} className="adm-label">
        {label}
        <span className="flex gap-1.5 mt-0">
          <input value={navn} onChange={(e) => setNavn(e.target.value)} placeholder="Navn på ny pakke"
            className="adm-input flex-1 min-w-0" autoFocus data-testid={`${testid}-ny-input`} />
          <button type="submit" className="adm-btn" data-testid={`${testid}-ny-lagre`}>Lagre</button>
          <button type="button" className="adm-btn-ghost" onClick={() => setNy(false)}>Avbryt</button>
        </span>
      </form>
    );
  }

  const kjent = pakker.some((p) => p.name === verdi);
  return (
    <label className="adm-label">
      {label}
      <select value={verdi || ""} className="adm-input" data-testid={testid}
        onChange={(e) => { if (e.target.value === "__ny") setNy(true); else onVelg(e.target.value); }}>
        <option value="">Ingen pakke</option>
        {!kjent && verdi && <option value={verdi}>{verdi}</option>}
        {pakker.map((p) => <option key={p.id} value={p.name}>{p.name}</option>)}
        <option value="__ny">+ Ny pakke …</option>
      </select>
    </label>
  );
}
